// Foundations
import { Injectable } from '@angular/core';

// rxjs
import { Observable } from 'rxjs';

// ENV
import { environment } from '../../environments/environment';
import { PetVaccination } from './graphql.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CognitoService, getAccessToken } from './cognito.service';

const BASE_URL = environment.glqBaseUrl;


@Injectable({
  providedIn: 'root',
})
export class S3Service {

  constructor(private http: HttpClient,
              private cognitoService: CognitoService) {}

  uploadVaccImg(file: File, petId: number, fileName: string): Observable<PetVaccination> {
    const formData: any = new FormData();
    formData.append('fileToUpload', file, fileName);

    const token = getAccessToken();
    const httpHeaders = new HttpHeaders({
       Authorization: `Bearer ${token}`,
    });
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };

    return this.http.post<PetVaccination>(`${BASE_URL}api/pets/` + petId + '/vaccination', formData,
      options);

    /* Use this if testing locally (proxy)
    return this.http.post<PetVaccination>(`s3Upload/api/pets/` + petId + '/vaccination', formData,
      options);
      */
  }
}
